import { useState } from 'react'
import { Row, Col, Card, Badge, Dropdown } from 'react-bootstrap'
import TextElement from '../elements/TextElement'

function Beneficios() {
  const [category, setCategory] = useState([])
  const [showCategory, setShowCategory] = useState([])
  const elements = [
    {
      name: 'Tosi Instituto Oftalmológico',
      content: 'Rua Antônio Xavier de Mendonça, 2-49 Vila Universitária<br>Telefone: 3224-2115<br>Desconto de R$100,00 na consulta',
      category: 'Clinica Oftalmológica'
    },
    {
      name: 'Dra. Elisa Rocha Caminaga',
      content: 'Rua Araujo Leite, 2-25 Centro<br>Telefone: 99814-1583<br>Desconto de 50%',
      category: 'Fisioterapia'
    },
    {
      name: 'Magna Diagnóstico por Imagem',
      content: 'Rua Monsenhor Claro, 7-77<br>Telefone: 3235-2500<br>Desconto conforme tabela da clínica nos seguintes exames:<br><br>-Mamografia<br>-Ultrasson<br>-Tomografia<br>-Raio X<br>-Desintometria<br>-Ressonancia Magnetica',
      category: 'Labotatório de Exames e Clínicas'
    },
    {
      name: 'Dr. Alvaro Ernesto Bien',
      content: 'Rua Saint Martin, 21-85<br>Telefone: 3223-4010<br>Desconto 50% em consultas',
      category: 'Labotatório de Exames e Clínicas'
    },
    {
      name: 'Biolab (Labotatório de Análise Clinicos)',
      content: 'Rua Gustavo Maciel, 16-40 / Rua Antonio Alves, 25-75<br>Telefone: 3214-34323262-2078<br>Descontos de até 20% em exames',
      category: 'Labotatório de Exames e Clínicas'
    },
    {
      name: '',
      content: '',
      category: 'Academias de musculação'
    },
    {
      name: '',
      content: '',
      category: 'Farmácias'
    },
    {
      name: '',
      content: '',
      category: 'Farmácias'
    },
    {
      name: '',
      content: '',
      category: 'Ótica'
    },
    {
      name: '',
      content: '',
      category: 'Pró clinica'
    },
    {
      name: '',
      content: '',
      category: 'Escolas particulares'
    },
    {
      name: '',
      content: '',
      category: 'Escolas particulares'
    },
    {
      name: '',
      content: '',
      category: 'Podólogas'
    },
    {
      name: '',
      content: '',
      category: 'Podólogas'
    },
    {
      name: '',
      content: '',
      category: 'Clinica veterinária'
    },
    {
      name: '',
      content: '',
      category: 'Oficinas'
    },
    {
      name: '',
      content: '',
      category: 'Som e acessórios'
    },
    {
      name: '',
      content: '',
      category: 'Salão de cabeleireiros'
    },
    {
      name: '',
      content: '',
      category: 'Salão de cabeleireiros'
    },
    {
      name: '',
      content: '',
      category: 'Colonia de férias'
    },
    {
      name: '',
      content: '',
      category: 'Atendimento jurídico'
    },
    {
      name: '',
      content: '',
      category: 'Área de lazer'
    },
    {
      name: '',
      content: '',
      category: 'Aulas de judô'
    },
  ]
  const categories = [...new Set(elements.map(e => e.category))].sort((a, b) => a.localeCompare(b))

  function categoryFilter(city) {
      let filtered = null
      if (city === 'Todas as cidades') {
          filtered = category
      } else {
          filtered = category.filter(item => item.city === city)
      }
      setShowCategory(filtered)
    }

  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12} style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
        <Dropdown>
          <Dropdown.Toggle variant="danger" id="dropdown-basic">
            Filtrar por categoria
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {categories?.map((category, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => categoryFilter(category)}
              >
                {category}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
      {elements.map((element) => 
        <Col style={{ marginBottom: '20px' }}>
          <Card style={{ width: '18rem' }}>
            {/* <Card.Img variant="top" src="https://placehold.co/400" /> */}
            <Card.Body>
              <Card.Title style={{ fontWeight: '700' }}>{element.name}</Card.Title>
              <Card.Text>
                <TextElement data={element} />
              </Card.Text>
              <Badge bg="danger">{element.category}</Badge>
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  )
}

export default Beneficios